module.exports = __webpack_public_path__ + "img/upcomingico.5bbfbe7.webp";